<template>
  <div class="mid-autumn">
    <!-- 活动标题 -->
    <div v-wechat-title='"余杭月饼铺开张营业！"'></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-hjwq' v-show='preloadingShow'></div>
    </transition>
    <Header
      :isOnline="1"
      :config='headerConfig'
      :isShowInfo='false' />
    <div class="help-page">
      <div class="home-page">
        <div class="help_btn">
          <div class="detail_btn" @click="openPopup('detailShow')"></div>
        </div>
        <div class="decorate_1"></div>
        <div class="decorate_2"></div>
        <div class="title">
          <transition enter-active-class="animated zoomInDown" leave-active-class="animated fadeOut" name="fade">
            <img v-show="titleShow" src="../../../../assets/images/active/hjwq/mid-autumn/title.png"/>
          </transition>
        </div>
        <div class="role_ani">
          <img src="../../../../assets/images/active/hjwq/mid-autumn/role_ani.gif" />
        </div>
        <div class="decorate_3"></div>
        <div class="egg_btn" @click="openPopup('eggShow')"></div>
        <div class="play_btn" @click="onHelp()">
          <img src="../../../../assets/images/active/hjwq/mid-autumn/help_btn.png" alt="">
        </div>
      </div>
      <Footer :gameName="gameName" />
    </div>
    <!-- 活动详情 -->
    <div class="detail_wrap popup_wrap" v-show="detailShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="detail_box" v-show="detailShow">
          <div class="detail">
            <img src="../../../../assets/images/active/hjwq/mid-autumn/popup/role_detail.png" alt="详情">
          </div>
        </div>
      </transition>
      <div class="close-bg" v-if="detailShow" @click="closePopup('detailShow')"></div>
    </div>
    <!-- 彩蛋 -->
    <div class="egg_wrap popup_wrap" v-show="eggShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="egg_box" v-show="eggShow" id="clipboard-egg-btn"
          :data-clipboard-text="eggText"  @click="onCopyEgg()"></div>
      </transition>
      <div class="close-bg" v-if="eggShow" @click="closePopup('eggShow')"></div>
    </div>
    <!-- 助力上限 -->
    <div class="help_max_wrap popup_wrap" v-show="helpMaxShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="help_max_box" v-show="helpMaxShow">
          <div class="confirm_btn" @click="closePopup('helpMaxShow')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="helpMaxShow" @click="closePopup('helpMaxShow')"></div>
    </div>
    <!-- 重复为好友助力 -->
    <div class="help_repeat_wrap popup_wrap" v-show="helpRepeatShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="help_repeat_box" v-show="helpRepeatShow">
          <div class="confirm_btn" @click="closePopup('helpRepeatShow')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="helpRepeatShow" @click="closePopup('helpRepeatShow')"></div>
    </div>
    <!-- 助力成功 -->
    <div class="help_success_wrap popup_wrap" v-show="helpSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="help_success_box" v-show="helpSuccessShow">
          <div class="confirm_btn" @click="closePopup('helpSuccessShow')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="helpSuccessShow" @click="closePopup('helpSuccessShow')"></div>
    </div>
    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
    <!-- 预加载图片 -->
    <img style="display: none" src="../../../../assets/images/active/hjwq/mid-autumn/popup/role_detail.png" alt="">
  </div>
</template>
<script>
import { Toast, Indicator } from 'mint-ui';
import Clipboard from 'clipboard';
import { mapMutations, mapActions } from 'vuex';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { headerConfig } from '../headerConfig';
import { getRandomString, buriedLogger, analysisParams } from '@/utils/utils';
import { onGetHelpInitDataAPI, onHelpAPI } from '../api';

export default {
  name: 'mid-autumn-help',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      headerConfig,
      gameName: 'hjwq',
      preloadingShow: false,
      titleShow: true,
      preventShow: false,

      logger: null,

      detailShow: false,
      eggShow: false,
      eggText: '小兔子乖乖',
      helpMaxShow: false,
      helpRepeatShow: false,
      helpSuccessShow: false,

      friendId: null,
      activeUrl: '',
    }
  },
  created () {
    // 获取参数
    const { protocol, host } = window.location;
    const params = analysisParams(window.location.href);
    this.friendId = params.id;

    if (!params.id) {
      this.onToast('无效链接！');
    }
    // 初始化授权
    onGetHelpInitDataAPI({ friend_id: this.friendId }).then((response) => {
      this.onInitDataCallback(response,
        {needAccount: false, needUpdateInfo: false}
      );
    });
    this.activeUrl = `${protocol}//${host}/hjwq/mid-autumn/enter${getRandomString()}`;

    // 埋点
    const bl = buriedLogger('hjwq', '中秋活动_助力页');
    this.logger = bl;

    this.setShare({
      title: '余杭月饼铺开张营业！',
      desc: '制作月饼赚金龙咯~',
      imgUrl: 'https://download4.qcplay.com/qcgame-admin/8TYvz9Cy2qyhLOYSn5lBbCgSDNNa0zsIKFmwiNHo.png',
      link: this.activeUrl
    });

  },
  methods: {
    onCopyEgg () {
      this.onCopy('#clipboard-egg-btn');
      this.logger.sum('中秋_助力_复制密令');
    },
    onHelp () {
      this.preventShow = true;
      Indicator.open();
      onHelpAPI({ friend_id: this.friendId }).then((response) => {
        this.preventShow = false;
        Indicator.close();
        const { code, message } = response;
        if (code === 200) {
          this.openPopup('helpSuccessShow');
        } else if (code === 403) { // 已帮助过
          this.openPopup('helpRepeatShow');
        } else if (code === 406) { // 最大助力
          this.openPopup('helpMaxShow');
        } else {
          this.onToast(message);
        }
      }).catch(() => {
        this.preventShow = false;
        Indicator.close();
      });
      this.logger.sum('中秋_助力_助力按钮');
    },
    // TAG: 其他简易封装的方法
    openPopup (name) {
      this[name] = true;
      const logConfig = {
        'detailShow': '活动详情',
        'eggShow': '彩蛋',
      };
      logConfig[name] && (this.logger.sum(`中秋_助力_打开${logConfig[name]}弹窗`));
    },
    closePopup (name) {
      this[name] = false;
    },
    // 复制
    onCopy (domName) {
      const clipboard = new Clipboard(domName);
      clipboard.on('success', (e) => {
        this.onToast('密令复制成功');
        e.clearSelection();
      });

      clipboard.on('error', (e) => {
        this.onToast('密令复制失败');
      });
    },
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([
      'setLogger'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'setShare'
    ])
  },
};
</script>
<style lang='less'>
  @import url('../index/index.less');
  @import url('./index.less');
</style>


// WEBPACK FOOTER //
// src/pages/hjwq/mid-autumn/help/index.vue